import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DistrictInput, DistrictResult, GetDistrictsInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {

  constructor(private httpClient: HttpClient) { }

  public addDistrict(districtInput: DistrictInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'District/AddDistrict', districtInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editDistrict(id: number, districtInput: DistrictInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'District/EditDistrict?id=' + id, districtInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteDistrict(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'District/DeleteDistrict?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getDistricts(getDistrictsInput: GetDistrictsInput, token: string): Promise<ResultList<DistrictResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'District/GetDistricts', getDistrictsInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<DistrictResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<DistrictResult>(), result.error));
  }
}
